import { useQuery } from '@tanstack/react-query';

import { createDefaultTaskStats, tasksApi, taskKeys } from '@features/tasks/api';
import type { TaskStats } from '@features/tasks/types';

async function fetchTaskStats(): Promise<TaskStats> {
  try {
    return await tasksApi.fetchTaskStats();
  } catch (error) {
    console.error('Failed to load tasks stats', error);
    return createDefaultTaskStats();
  }
}

export function useTasksCount() {
  return useQuery({
    queryKey: taskKeys.stats,
    queryFn: fetchTaskStats,
    refetchInterval: 30_000,
    staleTime: 20_000,
  });
}

